import { render } from "./WhatsappButton.vue?vue&type=template&id=b071e5e8&scoped=true"
import script from "./WhatsappButton.vue?vue&type=script&lang=js"
export * from "./WhatsappButton.vue?vue&type=script&lang=js"

import "./WhatsappButton.vue?vue&type=style&index=0&id=b071e5e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b071e5e8"]])

export default __exports__